import React from "react";
import BtnRight from "../../common/ButtonRight";
import Breadcrumb from "../../common/Breadcrumb";
import Reaching from "../../../Assets/img/mobile/reaching.png";
import Coffee from "../../../Assets/img/mobile/coffee.png";
import Healthcare from "../../../Assets/img/mobile/healthcare.png";
import { Link } from "react-router-dom";
import { SlArrowRight } from "react-icons/sl";
import { Text, Card, Button } from "@nikitamallya/react-ui-components";
import reactUI from "../../../Assets/img/reactui.png";
import WorkCard from "../../common/WorkCard";

export default function MobileApplication(props) {
  const mobileApps = [
    {
      img: Reaching,
      title: "Location Reaching App",
      subTitle: "A Location Sharing Application.",
      para: "",
      link: "https://www.figma.com/proto/IOpVtjvb8ftwE2bqSnfcZs/Reaching_Location_Sharing_App?type=design&node-id=1-2&t=RBKSGfZDC0ePcCaQ-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=1%3A2&mode=design",
    },
  ];
  return (
    <div>
      <div className={`${props.mode}`}>
        <Breadcrumb
          title="Mobile Application"
          to1="/works/frontend"
          label1="Front-end Development"
          icon1={<SlArrowRight />}
          to2="/works/emails"
          label2="Responsive Email Design"
          icon2={<SlArrowRight />}
          to3="/works/uxui"
          label3="UX/UI"
          icon3={<SlArrowRight />}
          to4="/works/digital-assets"
          label4="Digital Asset"
          icon4={<SlArrowRight />}
        />
      </div>
      <div className={`section pb-5 pt-7 works ${props.mode}`}>
        <div className="row pb-4">
          <div className="col-md-6">
            <WorkCard
              title="Reaching App"
              description="A Location Sharing App"
              image={Reaching}
              figmaLink="https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10"
              csLink="https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10"
            />
          </div>
          <div className="col-md-6">
            <WorkCard
              title="Reaching App"
              description="A Location Sharing App"
              image={Reaching}
              figmaLink="https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10"
              csLink="https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
